import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPageSearch = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	strokeWidth: 1.5,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#000000",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20 12V5.74853C20 5.5894 19.9368 5.43679 19.8243 5.32426L16.6757 2.17574C16.5632 2.06321 16.4106 2 16.2515 2H4.6C4.26863 2 4 2.26863 4 2.6V21.4C4 21.7314 4.26863 22 4.6 22H11",
			stroke: "#000000",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 10H16M8 6H12M8 14H11M20.5 20.5L22 22M15 18C15 19.6569 16.3431 21 18 21C18.8299 21 19.581 20.663 20.1241 20.1185C20.6654 19.5758 21 18.827 21 18C21 16.3431 19.6569 15 18 15C16.3431 15 15 16.3431 15 18Z",
			stroke: "#000000",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 2V5.4C16 5.73137 16.2686 6 16.6 6H20",
			stroke: "#000000",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgPageSearch;
